import React from 'react';
import { Button, Text } from '@spark';
import ModelProvidersOnboardingModal from '@/features/settings/components/ModelProvidersOnboardingModal.jsx';
import { useCreateModelEntry } from '@/features/tasks/hooks/useCreateModelEntry';
import './CreateModelEmptyState.css';

export const CREATE_FIRST_MODEL_CTA = 'Create Your First Model';

/**
 * Empty-state card whose CTA opens the model-creation wizard through the same
 * provider-credentials gate as the Projects header button. Used by the
 * Datasets (Figma 9750:37195) and Models (Figma 9750:37015) tabs.
 */
export const CreateModelEmptyState = ({ illustrationSrc, title, description, className = '' }) => {
    const {
        openCreateModel,
        isProvidersOnboardingOpen,
        closeProvidersOnboardingModal,
        continueFromProvidersOnboarding,
    } = useCreateModelEntry();

    return (
        <>
            <div
                className={`create-model-empty-state ${className}`.trim()}
                data-testid="create-model-empty-state"
            >
                <div className="create-model-empty-state__body">
                    <img
                        src={illustrationSrc}
                        alt=""
                        aria-hidden="true"
                        className="create-model-empty-state__illustration"
                    />
                    <div className="create-model-empty-state__copy">
                        <Text
                            as="h2"
                            variant="heading-5-semibold"
                            color="primary"
                            className="create-model-empty-state__title"
                        >
                            {title}
                        </Text>
                        <Text
                            as="p"
                            variant="base-regular"
                            color="secondary"
                            className="create-model-empty-state__description"
                        >
                            {description}
                        </Text>
                    </div>
                </div>
                <Button
                    variant="primary"
                    size="large"
                    disableWhenReadOnly
                    onClick={openCreateModel}
                    className="create-model-empty-state__cta"
                >
                    {CREATE_FIRST_MODEL_CTA}
                </Button>
            </div>
            <ModelProvidersOnboardingModal
                open={isProvidersOnboardingOpen}
                onClose={closeProvidersOnboardingModal}
                onContinue={continueFromProvidersOnboarding}
            />
        </>
    );
};

export default CreateModelEmptyState;
